<template>
     <SlideFadeTransition>
        <div v-show="showMessage" class="alert my-2" :class="`alert-${alertContext}`" role="alert">
            <i class="bi bi-exclamation-circle-fill me-2"></i>
            <span v-show="showPrefix">{{ messagePrefix }}</span>
            {{ message }}
        </div>
     </SlideFadeTransition>
</template>

<script setup lang="ts">
import { computed } from "vue";
import SlideFadeTransition from "./SlideFadeTransition.vue";

const props = defineProps({
    message: { type: String, default: "", required: true },
    messagePrefix: { type: String, default: "" },
    alertContext: { type: String, default: "warning" }
});

const showMessage = computed<boolean>(() => props.message.length > 0);

const showPrefix = computed<boolean>(() => props.messagePrefix.length > 0);
</script>
